import React from 'react'
import parse from 'html-react-parser'

const baseClasses = 'prose prose-sm max-w-none prose-li:marker:text-current'

export default function RichText({ content, className = '', invert = false, columns = false }) {
  if (!content) return null

  const invertClass = invert ? 'prose-invert' : ''
  const columnsClass = columns ? 'md:columns-2 md:gap-8' : ''

  return (
    <div className={`${baseClasses} ${invertClass} ${columnsClass} ${className}`}>
      {parse(content)}
    </div>
  )
}
